import { htmlParse } from "@unisearch/helpers";
import React from "react";
import styles from "./heading.module.scss";

const HeadingCourse = ({ universityProfileData, courseOverviewText }) => {
  return (
    <div className={styles.heading_wrapper}>
      <h2 className={styles.heading}>All Courses</h2>
      {courseOverviewText ? (
        <>{htmlParse(courseOverviewText)}</>
      ) : (
        <p className={styles.short_description}>
          Explore the courses{" "}
          <strong> {universityProfileData?.universityName}</strong> has to offer
          to find the right program for you!
        </p>
      )}
    </div>
  );
};

export default HeadingCourse;
